
import s from './App'
export default s
